import cubejs from '@cubejs-client/core';
import { url } from '../config/urls';

const API_URL = url.cubeApiUrl;

const getDataFromCube = (str, type, filters = [], from, customProps = undefined) => {
    let cubejsApi
    const CUBE_TOKEN = localStorage.getItem('cubeToken')
    if (CUBE_TOKEN) {
        cubejsApi = cubejs(CUBE_TOKEN, { apiUrl: `${API_URL}/cubejs-api/v1` })
    } else {
        cubejsApi = ""
    }
    let queryObj = {};
    //console.log(from)
    if (from === "limitReportFiter") {
        let dimFieldArr = []
        let { filter, reportDetails } = customProps
        const { member, operator, limit, dataSetType } = filter
        const { dimensions } = reportDetails?.reportDetails


        queryObj.limit = limit;
        queryObj.order = {}
        queryObj.order[member] = operator === 'top' ? 'desc' : 'asc'

        if (dataSetType === 'MEASURE') {
            if (dimensions?.length) {
                dimFieldArr = dimensions?.filter(dim => dim?.fieldName !== member).map(ele => ele?.fieldName)
            }
            queryObj.dimensions = [...dimFieldArr];
            queryObj.measures = [member];
        }
        else {
            queryObj.dimensions = [member];
        }
    } else if (from === 'joinModule') {
        const { measures, dimensions, limit } = customProps;
        queryObj.measures = measures;
        queryObj.dimensions = dimensions;
        queryObj.limit = limit;
    } else if (from === "filterDynamicLabel") {

        const { dataSetType, label } = customProps
        if (!str || !type)
            return [];
        let measures = [];
        let dimensions = [];

        if ("MEASURE" === type) {
            measures[0] = str;
        } else if ("DIMENSION" === type) {
            dimensions[0] = str;
        }
        dataSetType === 'MEASURE' ? measures[1] = label : dimensions[1] = label
        queryObj.measures = measures;
        queryObj.dimensions = dimensions;
    } else if (from === "static_dashboard") {
        let dataSetName
        if (typeof customProps === 'object') {
            let dimensions = [...customProps];
            dataSetName = customProps[0].split('.')[0]
            queryObj.dimensions = dimensions
        }
        else if (typeof customProps === 'string') {
            let dimensions = [customProps];
            dataSetName = customProps.split('.')[0]
            queryObj.dimensions = dimensions
        }
        if (str == 'limit') {
            queryObj.limit = 100
            queryObj.order = {}
            queryObj.order[`${dataSetName}.syncDate`] = 'desc'
        }


    } else if (from === "custom_query_data") {
        queryObj = customProps
        queryObj.limit = 50
    } else {

        if (!str || !type)
            return [];
        let measures = [];
        let dimensions = [];

        if ("MEASURE" === type) {
            measures[0] = str;
        } else if ("DIMENSION" === type) {
            dimensions[0] = str;
        }

        queryObj.measures = measures;
        queryObj.dimensions = dimensions;
        queryObj.limit = 50
    }

    if (filters && filters.length) {
        const queryFilter = filters.filter(f => {

            if (f?.operator !== 'set' && f?.operator !== 'notSet') {
                if (f && f?.member && f?.operator && f?.values && f?.values?.length) {
                    if (typeof f?.values[0] === 'number') {
                        f.values = f?.values?.map(v => v?.toString())
                    }
                    return f
                }
            }
            return f
        })
        queryObj.filters = queryFilter
    }
    queryObj.renewQuery = false

    return cubejsApi.load(queryObj).then((res) => {
        let newList = []
        let data = res.rawData()
        //console.log(data,'test')
        if (data?.length > 0) {
            for (let i = 0; i < data?.length; i++) {
                if (from === 'joinModule' || from === "limitReportFiter" || from === 'filterDynamicLabel' || from === "static_dashboard" || from === "custom_query_data") {
                    newList.push(data[i])
                }
                else if (data[i]?.[str]) {
                    newList.push(data[i]?.[str])
                }
            }
        }
        return newList;
    })
        .catch((err) => {
            console.error(err)
            return [];
        })
}

export default getDataFromCube;

export function getRateChangeQueryData(query) {
    try {
        if (!query)
            return new Error('Invalid query');

        const CUBE_TOKEN = localStorage.getItem('cubeToken');
        if (!CUBE_TOKEN)
            return new Error('Invalid cube token');

        return cubejs(CUBE_TOKEN, { apiUrl: `${API_URL}/cubejs-api/v1` })
            .load(query)
            .then((res) => {
                return res
            })
            .catch((err) => { return err });
    } catch (error) {
        console.error(error)
    }
}